import { LocalDate, ZoneId } from 'js-joda';
import React from 'react';

/**
 * Obtain a ref to the current day, which will update if the clock ticks over to the following day.
 * Defaults to using UTC if a timezone is not supplied.
 */
export const useCurrentDayRef = (timezone?: string) => {
  // Use this time zone for anything that has to do with LocalDate.now() . In practice currentMetroArea
  // should be set, and the timezone passed as param will come from currentMetroArea. If it isn't we'll use UTC as a fallback.
  const timeZone = ZoneId.of((timezone as string) ?? 'UTC');

  const todayRef = React.useRef(LocalDate.now(timeZone));
  // If the clock ticks over while the component is rendered, update todayRef.current
  const maybeNewToday = LocalDate.now(timeZone);
  if (maybeNewToday.isAfter(todayRef.current)) {
    todayRef.current = maybeNewToday;
  }
  return todayRef.current;
};
